export default class ScrollToTop {
    constructor() {
        this.btn = document.getElementById('scroll-to-top');
        this.sentinel = document.getElementById('scroll-sentinel');
        if (!this.btn || !this.sentinel) return;

        this.observer = null;
        this.init();
    }

    init() {
        this.btn.addEventListener('click', () => this.scrollToTop());

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    this.btn.classList.toggle('is-visible', !entry.isIntersecting);
                });
            },
            { rootMargin: '-1px 0px 0px 0px' }
        );

        this.observer.observe(this.sentinel);
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
